module.exports = __webpack_public_path__ + "static/media/cloud-meatball.df53c8f9.svg";